import { render, staticRenderFns } from "./AffiliationsCompany.vue?vue&type=template&id=17e76d93&lang=pug&"
import script from "./AffiliationsCompany.vue?vue&type=script&lang=ts&"
export * from "./AffiliationsCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports